import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [restaurants, setRestaurants] = useState([]);
  const [restaurant, setRestaurantState] = useState(null);

  const loadRestaurants = useCallback(async () => {
    const { data } = await api.get("/restaurants");
    setRestaurants(data);
    const savedId = localStorage.getItem("mo_rid");
    const chosen = data.find((r) => r.id === savedId) || data[0] || null;
    setRestaurantState((prev) => (chosen && prev?.id === chosen.id ? { ...chosen, slug: chosen.slug || prev.slug } : chosen));
    return data;
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    if (!localStorage.getItem("mo_token")) { setUser(false); return; }
    api.get("/auth/me").then(async ({ data }) => { setUser(data); await loadRestaurants(); }).catch(() => { localStorage.removeItem("mo_token"); setUser(false); });
  }, [loadRestaurants]);

  const onAuth = async (data) => {
    localStorage.setItem("mo_token", data.token);
    setUser(data.user);
    await loadRestaurants();
  };

  const login = async (email, password) => onAuth((await api.post("/auth/login", { email, password })).data);
  const staffLogin = async (code) => onAuth((await api.post("/auth/staff-login", { code })).data);
  const register = async (payload) => onAuth((await api.post("/auth/register", payload)).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("mo_token"); localStorage.removeItem("mo_rid");
    setUser(false); setRestaurants([]); setRestaurantState(null);
  };
  const setRestaurant = (r) => { localStorage.setItem("mo_rid", r.id); setRestaurantState(r); };

  return (
    <AuthContext.Provider value={{ user, login, staffLogin, register, logout, applyAuth: onAuth, restaurants, restaurant, setRestaurant, reloadRestaurants: loadRestaurants }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
